import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import React from 'react';
import TableRow from "../../TableRow";
import TableHeader from "../../TableHeader";
import TableHeading from "../../TableHeading";
import clsx from 'clsx';

import Button from "../../Button";
import colors from "../../../utils/colors";
import { createStyles } from "./styles";
import ProposalTableHeading from "./ProposalTableHeading";
import MultiVariantsHeading from "./MultiVariantsHeading";
import MultiProductsHeading from "./MultiProductsHeading";
import { isVariantAddedToCart, isVariantPredefined } from "../utils";

var ComparisonTableHeader = function ComparisonTableHeader(_ref)












{var cartItems = _ref.cartItems,portfolios = _ref.portfolios,productLineId = _ref.productLineId,addButtonTitle = _ref.addButtonTitle,removeButtonTitle = _ref.removeButtonTitle,onAddToProposal = _ref.onAddToProposal,onRemoveFromProposal = _ref.onRemoveFromProposal,onConfigure = _ref.onConfigure,lastUpdateBcShortName = _ref.lastUpdateBcShortName,showWideColumns = _ref.showWideColumns,loaderInPortfolioId = _ref.loaderInPortfolioId,highlightBCAndConfigurePortfolio = _ref.highlightBCAndConfigurePortfolio;
  var classes = createStyles();

  var AddToProposalButton = function AddToProposalButton(
  portfolioId,
  bcIndex,
  portfolioName,
  disabled)
  {
    return /*#__PURE__*/(
      React.createElement(Button, {
        size: "large",
        color: "primary",
        disabled: disabled,
        className: classes.actionButton,
        onClick: function onClick() {
          if (onAddToProposal) onAddToProposal(portfolioId, bcIndex, portfolioName, productLineId);
        } },

      addButtonTitle));


  };

  var ConfigureButton = function ConfigureButton(
  portfolioId,
  bcIndex,
  portfolioName,
  disabled)
  {
    return /*#__PURE__*/(
      React.createElement(Button, {
        size: "medium",
        color: "primary",
        type: "text",
        disabled: disabled,
        className: classes.configureButton,
        onClick: function onClick() {
          if (onConfigure) onConfigure(portfolioId, portfolioName, productLineId, bcIndex);
        } }, "Configure Portfolio"));




  };

  var RemoveFromProposalButton = function RemoveFromProposalButton(
  portfolioId,
  bcIndex,
  disabled)
  {
    return /*#__PURE__*/(
      React.createElement(Button, {
        size: "large",
        className: classes.actionButton,
        color: "custom",
        customColor: colors.red[600],
        type: "outlined",
        disabled: disabled,
        onClick: function onClick() {
          if (onRemoveFromProposal) onRemoveFromProposal(portfolioId, bcIndex);
        } },

      removeButtonTitle));


  };

  var RemoveActionButton =
  removeButtonTitle && onRemoveFromProposal ? RemoveFromProposalButton : null;
  var AddActionButton = onAddToProposal && addButtonTitle ? AddToProposalButton : null;
  var ConfigureActionButton =
  onConfigure && highlightBCAndConfigurePortfolio ? ConfigureButton : null;

  var headings = _mapInstanceProperty(portfolios).call(portfolios, function (portfolio) {
    var products = portfolio.products,id = portfolio.id,bcVersions = portfolio.bcVersions;

    // If portfolio is added to cart, cartItem with this portfolio id will exist
    var currentCartItem = _findInstanceProperty(cartItems).call(cartItems, function (cartItem) {return cartItem.portfolioId === id;});

    var headingsList = [];

    var isVariantAdded = false;

    products.forEach(function (product) {var _context;
      var imProductId = product.imProductId,productDisplayName = product.productDisplayName,bcDependentData = product.bcDependentData,disabled = product.disabled;

      // Amount of variants for each product
      var variantsAmount = _Object$values(bcDependentData).length;
      //  Headings formation
      //  If portfolio has only 1 product and 1 variant, returning value is TableHeading
      //  If it has some products, some variants or both, returning value is div, which will be used as content in heading wrapper below
      //  It is needed for general title for some products or variants
      var bcHeadings = _mapInstanceProperty(_context = _Object$entries(bcDependentData)).call(_context, function (_ref2) {var _bcVersions$bcIndex, _context2;var _ref3 = _slicedToArray(_ref2, 2),bcIndex = _ref3[0],rates = _ref3[1].rates;
        // bcIndex has its own rates and attribute values for each variant
        isVariantAdded = isVariantAddedToCart(currentCartItem, Number(bcIndex));

        var predefinedValue = isVariantPredefined(currentCartItem, Number(bcIndex));
        var shortName =
        isVariantAdded || predefinedValue ?
        ((_bcVersions$bcIndex = bcVersions[bcIndex]) === null || _bcVersions$bcIndex === void 0 ? void 0 : _bcVersions$bcIndex.shortName[productLineId]) || lastUpdateBcShortName :
        lastUpdateBcShortName;

        return /*#__PURE__*/(
          React.createElement(ProposalTableHeading, {
            key: _concatInstanceProperty(_context2 = "heading_".concat(imProductId, "_")).call(_context2, bcIndex),
            portfolio: portfolio,
            productName: productDisplayName,
            imProductId: imProductId,
            browsingShortName: shortName,
            isPortfolioAddedToCart: isVariantAdded,
            disabled: disabled,
            variantsAmount: variantsAmount,
            bcIndex: +bcIndex,
            rates: rates,
            removeButton: RemoveActionButton,
            addButton: AddActionButton,
            configureButton: ConfigureActionButton,
            showWideColumns: showWideColumns,
            loaderInPortfolioId: loaderInPortfolioId,
            highlightBCAndConfigurePortfolio: highlightBCAndConfigurePortfolio }));


      });

      // Wrapper for multi variants portfolio with 1 product
      // Return TableHeading with general portfolio name for both variants
      if (variantsAmount > 1 && products.length === 1) {
        var multiHeader = /*#__PURE__*/
        React.createElement(MultiVariantsHeading, {
          portfolio: portfolio,
          key: "".concat(imProductId, "_variants"),
          isPortfolioAddedToCart: !!(currentCartItem && removeButtonTitle && addButtonTitle),
          headingContent: bcHeadings,
          variantsAmount: variantsAmount,
          loaderInPortfolioId: loaderInPortfolioId });


        headingsList.push(multiHeader);
      }

      if (variantsAmount === 1) {
        headingsList.push.apply(headingsList, _toConsumableArray(bcHeadings));
      }
    });

    return products.length === 1 ?
    headingsList :
    [/*#__PURE__*/
    // Wrapper for multi products portfolio
    // Return TableHeading with general portfolio name for all products, bc block and action button
    React.createElement(MultiProductsHeading, {
      key: "".concat(id, "_header"),
      portfolio: portfolio,
      currentCartItem: currentCartItem,
      headingContent: headingsList,
      lastUpdateBcShortName: lastUpdateBcShortName,
      removeButton: RemoveActionButton,
      addButton: AddActionButton,
      configureButton: ConfigureActionButton,
      products: products,
      productLineId: productLineId,
      loaderInPortfolioId: loaderInPortfolioId,
      highlightBCAndConfigurePortfolio: highlightBCAndConfigurePortfolio })];


  });

  return /*#__PURE__*/(
    React.createElement(TableHeader, { className: classes.tableHeader }, /*#__PURE__*/
    React.createElement(TableRow, null, /*#__PURE__*/
    React.createElement(TableHeading, { className: clsx(classes.attributeHeading, classes.tableHeading) }, "Plan name"),


    headings)));



};

export default ComparisonTableHeader;
//# sourceMappingURL=index.js.map